import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { Button, Container, Icon } from 'semantic-ui-react'
import { FaFlag } from 'react-icons/fa'
import { loadEsrbList, removeEsrb, updateState } from '../Slice/EsrbSlice'
import ListTable from '../../Common/Views/ListTable'
import DeleteConfirmModal from '../../Common/Views/DeleteConfirmModal'
import './css/EsrbListPage.css'

export default function EsrbListPage () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    list,
    filter,
    totalPages,
    isLoading,
    isError,
    message
  } = useSelector((state) => state.esrb)
  const [deleteEsrb, setDeleteEsrb] = useState({})

  const columns = [
    {
      name: 'id',
      title: 'generic.id',
      filter: false,
      props: {
        textAlign: 'right',
        width: 1
      }
    },
    {
      name: 'name',
      title: 'generic.name'
    }
  ]

  useEffect(() => {
    onReload(filter)
  }, [])

  const onReload = (payload) => {
    dispatch(loadEsrbList(payload))
  }

  useEffect(() => {
    if (isError && message) {
      toast.error(message)
      dispatch(updateState())
    }
  }, [isError, message])

  const onEdit = (esrbId) => {
    navigate(`/esrb/${esrbId}`)
  }
  const onDelete = (esrb) => {
    setDeleteEsrb(esrb)
  }

  const handleDeleteEsrb = () => {
    dispatch(removeEsrb(deleteEsrb.id))
    setDeleteEsrb({})
  }

  return (
    <Container className='esrb-list-page'>
      <div className='esrb-title'>
        <Icon size='large'><FaFlag /></Icon>
        <span>{ t('menu.esrb') }</span>
        <Button
          floated='right'
          icon
          labelPosition='left'
          primary
          size='large'
          onClick={() => navigate('/esrb/new')}>
          <Icon name='flag' /> { t('esrb.new') }
        </Button>
      </div>
      <ListTable color='yellow'
                 isLoading={isLoading}
                 columns={columns}
                 filter={filter}
                 data={list}
                 totalPages={totalPages}
                 onReload={onReload}
                 onEdit={onEdit}
                 onDelete={onDelete} />
      <>
        <DeleteConfirmModal open={ !!deleteEsrb.id }
                            title={ t('esrb.deleteTitle') }
                            message={ t('esrb.deleteQuestion') }
                            item={ deleteEsrb.name }
                            onCancel={ () => setDeleteEsrb({}) }
                            onDelete={ handleDeleteEsrb } />
      </>
    </Container>
  )
}
